import * as types from './mutations-types'

export const setButtonVisible = (context, visible) =>
  context.commit(types.SET_BUTTON_VISIBLE, visible)

export const toggleButton = context => context.commit(types.BUTTON_TOGGLE)
